import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { NZ_MODAL_DATA } from "ng-zorro-antd/modal";

export interface MerchantDetailChange {
    label: string;
    from: string;
    to: string;
}

interface MerchantDetailsUpdateModalData {
    merchantName: string;
    changes: MerchantDetailChange[];
}

@Component({
    selector: "app-merchant-details-update-modal",
    templateUrl: "./merchant_details_update_modal.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MerchantDetailsUpdateModalComponent {
    constructor(
        @Inject(NZ_MODAL_DATA)
        public readonly data: MerchantDetailsUpdateModalData
    ) {}
}
